import React from "react";
import { Link } from "react-router-dom";
import "../styles/Globals.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const About: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className="flex min-h-screen flex-col bg-[#f8f8f8] text-[#333333]">
      <main className={`container mx-auto flex flex-1 flex-col items-center px-4 py-12 text-center ${isMobile ? 'justify-start pt-8 pb-24' : 'justify-center'}`}>
        <div className="relative mb-8 w-24 h-[21px]">
          <div className="absolute top-0 left-16 w-8 h-[1px] bg-[#333333]/20"></div>
          <div className="absolute top-[10px] left-8 w-8 h-[1px] bg-[#333333]/20"></div>
          <div className="absolute top-[20px] left-0 w-8 h-[1px] bg-[#333333]/20"></div>
          <div className="absolute top-[1px] left-16 w-[1px] h-[9px] bg-[#333333]/20"></div>
          <div className="absolute top-[11px] left-8 w-[1px] h-[9px] bg-[#333333]/20"></div>
          <div
            className="absolute h-[3px] w-[3px] bg-[#333333]/40 animated-cube"
            style={{ top: "16px", left: "0px" }}
          ></div>
        </div>

        <h1 className="mb-6 max-w-md text-3xl font-light tracking-wide md:text-4xl">
          about crackd
        </h1>

        <div className="mb-10 max-w-2xl text-sm font-light text-[#333333]/70">
          <p className="mb-2">
            Crackd is a platform where technical students can compare their
            skills with peers.
          </p>
          <p className="mb-2">
            We aim to help students understand where they stand in terms of
            technical abilities, <br className="hidden md:block" />
            and remove biases from the assessment process.
          </p>
          <p className="mb-2">
            This platform is currently under development. More information
            coming soon!
          </p>
        </div>

        <div className="group relative inline-block overflow-hidden">
          <Link
            to="/"
            className="inline-flex items-center border border-[#333333]/20 rounded-md px-4 py-2 text-sm font-light transition-all hover:border-[#333333]/60 cursor-pointer"
          >
            Back to Home
          </Link>
        </div>
      </main>
    </div>
  );
};

export default About;
